import { TokenResponse, useGoogleLogin } from '@react-oauth/google';
import { useEffect, useRef } from 'react';

import { ILocaleText } from '@lib/tools/locale/views/LocaleFragment';
import { GOOGLE } from '@lib/tools/shared/helpers/consts';

import AuthorizationButton from '@components/web/src/atoms/Buttons/SocialButtons/AuthorizationButton/AuthorizationButton';

type Props = {
  isDisabled?: boolean;
  isHidden?: boolean;
  isRegistrationPage?: boolean;
  isPopupRedirect?: boolean;
  shouldStartGoogleOnMount?: boolean;
  isUserAuthenticated?: boolean;
  authOptions?: Record<string, any>;
  text?: ILocaleText;
  handleGoogleButtonClick?: () => void;
  responseGoogle?: (tokenResponse: TokenResponse) => void;
};

const GoogleLoginButton = ({
  isDisabled = false,
  isHidden = false,
  isRegistrationPage = false,
  isPopupRedirect = false,
  shouldStartGoogleOnMount = false,
  isUserAuthenticated = false,
  authOptions = {},
  responseGoogle,
  text = '',
  handleGoogleButtonClick,
}: Props) => {
  const hasAutoStartedGoogle = useRef(false);

  const login = useGoogleLogin({
    onError: error => {
      console.error('Login Failed with error:', error);
    },
    onNonOAuthError: error => {
      console.error('Non OAuth Error:', error);
    },
    onSuccess: (tokenResponse: TokenResponse) => {
      try {
        responseGoogle?.(tokenResponse);
      } catch (error) {
        console.error('Error in responseGoogle callback:', error);
      }
    },
  });

  useEffect(() => {
    if (
      !shouldStartGoogleOnMount ||
      isUserAuthenticated ||
      isPopupRedirect ||
      isDisabled ||
      isHidden ||
      hasAutoStartedGoogle.current
    ) {
      return;
    }

    hasAutoStartedGoogle.current = true;
    login();
  }, [shouldStartGoogleOnMount, isUserAuthenticated, isPopupRedirect, isDisabled, isHidden, login]);

  return (
    <AuthorizationButton
      key={GOOGLE}
      isDisabled={isDisabled}
      isHidden={isHidden}
      text={text || (isRegistrationPage ? authOptions.googleSignup : authOptions.googleLogIn)}
      type={GOOGLE}
      variant="secondary"
      handleClick={() => {
        if (isPopupRedirect) {
          handleGoogleButtonClick?.();
          return;
        }

        login();
      }}
    />
  );
};

export default GoogleLoginButton;
